module.exports = __webpack_public_path__ + "img/kkb_artnet_interface.9cb943d7.jpg";